import React, { useState } from 'react';
import './PatchworkPlanetPromo.css';

const ANDROID_PLAY_STORE = "https://play.google.com/store/apps/details?id=co.uk.sportsbuff.patchworkplanet";

export default function PatchworkPlanetPromo() {
  const [visible, setVisible] = useState(true);

  if (!visible) return null;

  return (
    <div className="ppp-overlay" onClick={() => setVisible(false)}>
      <div className="ppp-banner-wrap" onClick={(e) => e.stopPropagation()}>

        <div className="ppp-banner">

          {/* Top gold separator */}
          <div className="ppp-separator" />

          {/* Maroon header band */}
          <div className="ppp-header-edge-top" />
          <div className="ppp-header-light-top" />
          <div className="ppp-header-main">
            <span className="ppp-header-text">NEW RELEASE!</span>
          </div>
          <div className="ppp-header-light-bottom" />
          <div className="ppp-header-edge-bottom" />

          {/* Parchment content with sunburst + logo */}
          <div className="ppp-cream-edge-top" />
          <div className="ppp-cream-light-top" />
          <div className="ppp-cream-main">
            <img src="/PatchworkPlanet/logo.png" alt="Patchwork Planet" className="ppp-logo" />
            <p className="ppp-cream-copy"><strong>MATCH | PATCH | EXPLORE</strong></p>
          </div>
          <div className="ppp-cream-light-bottom" />
          <div className="ppp-cream-edge-bottom" />

          {/* Maroon footer band with store badges */}
          <div className="ppp-footer-edge-top" />
          <div className="ppp-footer-light-top" />
          <div className="ppp-footer-main">
            <a
              href="https://sportsbuff.co.uk/PatchworkPlanet/download.html"
              className="ppp-store-btn"
            >
              <img src="/MatchdayChampion/apple.png" alt="Download on the App Store" />
            </a>
            <a
              href={ANDROID_PLAY_STORE}
              target="_blank"
              rel="noopener noreferrer"
              className="ppp-store-btn"
            >
              <img src="/MatchdayChampion/google.png" alt="Get it on Google Play" />
            </a>
          </div>
          <div className="ppp-footer-light-bottom" />
          <div className="ppp-footer-edge-bottom" />

          {/* Bottom gold separator */}
          <div className="ppp-separator" />

        </div>
      </div>
    </div>
  );
}
